import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const ShopperAiFlagKey = {
  CONCIERGE_CONVERSATION_ANALYSIS: featureFlagKey(
    "concierge-conversation-analysis",
  ), // Trigger per-conversation LLM analysis of concierge (shopper-agent) channel threads (default OFF, enable per-team)
  MERCHANT_SHOPPER_AGENT_ONBOARDING_ASYNC: featureFlagKey(
    "merchant-shopper-agent-onboarding-async",
  ), // Enable the in-app async setup guide widget for the Concierge/shopper-agent product.
  SHOPPER_AGENT: featureFlagKey("shopper-agent"), // Enable Shopper Agent (Text Concierge) nav item in merchant app
  SHOPPER_AGENT_SETTINGS_CRDB_READ: featureFlagKey(
    "shopper-agent-settings-crdb-read",
  ), // Read from CRDB published version instead of Mongo blob. Dual-write always on; backfill first. Default OFF.
  SHOPPER_AGENT_SUPERVISOR: featureFlagKey("shopper-agent-supervisor"), // Kill switch for the on-loop shopper agent supervisor on reply and outreach paths
  SHOPPER_AGENT_TURBOPUFFER_PRODUCT_SEARCH: featureFlagKey(
    "shopper-agent-turbopuffer-product-search",
  ), // Product search via Turbopuffer product-families namespaces (default OFF until backfill)
  IMESSAGE_CHANNEL_AB_TEST: featureFlagKey("imessage-channel-ab-test"), // Enrolls iMessage-capable customers on a team into the iMessage-vs-SMS-forced A/B test. Default off. Eligibility filters to capability=available (from imessage_phone_capability); arm assignment is sticky per (team, customer) and persisted in imessage_channel_experiment_assignment.
} as const;
